























import {Component, Vue} from "vue-property-decorator";
import {ACTION_SELECT_LESSON, ACTION_SELECT_LEVEL, LessonProgress} from "../store/CourseProgress";

@Component
export default class Level extends Vue {
    mounted() {
        // TODO This could show the wrong level for the route-params when the state isn't empty!
        if (!this.$store.getters.hasCurrentLevel) {
            // We have no level. Maybe we can set it from the route-props?
            const lessonId = this.$route.params["lessonId"];
            const levelId = parseInt(this.$route.params["levelId"]);
            this.$store.dispatch(ACTION_SELECT_LESSON, lessonId);
            this.$store.dispatch(ACTION_SELECT_LEVEL, levelId);
        }
    }

    get levelName() {
        const level = this.$store.getters.currentLevel;
        return level ? level.name : "";
    }
    get levelList() {
        return this.$store.getters.levels;
    }
    get selectedLevel() {
        return this.$store.state.CourseProgressModule.currentLevel;
    }

    changeLevel(newLevel: number) {
        // TODO this could be easier... use vuex-router-sync?
        this.$store.dispatch(ACTION_SELECT_LEVEL, newLevel);
        this.$router.push(`/lessons/${this.$route.params["lessonId"]}/levels/${newLevel}`);
    }
}
